<template>
  <div>
    <h2 class="mb-8 grey--text">
      {{ $t('recharge.cardInformations') }}
    </h2>

    <v-row>
      <v-col>
        <v-text-field
          @input="handleUpdateRechargeFields"
          v-model="credit_card.info.holder_name"
          :rules="[rules.name]"
          :label="$t('forms.nameAsCreditCard')"
          hide-details="auto"
          type="text"
          outlined
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          @input="handleUpdateRechargeFields"
          v-model="cardNumber"
          :rules="[rules.number]"
          :label="$t('forms.creditCardNumber')"
          v-mask="'#### #### #### ####'"
          type="tel"
          hide-details="auto"
          outlined
        />
      </v-col>
      <v-col cols="8" md="4">
        <v-text-field
          @input="handleUpdateRechargeFields"
          v-model="expiry"
          v-mask="'##/####'"
          :error="expiryMonthError"
          :rules="[
            rules.required,
            rules.expiredMonthValidation,
            rules.expiredYearValidation,
          ]"
          :label="$t('forms.cardDate')"
          :hint="$t('onboarding.card.dueDateHint')"
          type="tel"
          hide-details="auto"
          outlined
        />
      </v-col>
      <v-col cols="4" md="2">
        <v-text-field
          @input="handleUpdateRechargeFields"
          v-model="credit_card.info.ccv"
          :rules="[rules.ccv]"
          :label="$t('forms.cardCvv')"
          v-mask="'####'"
          type="tel"
          hide-details="auto"
          hint="Ex.: 123"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import {
  name,
  required,
  expiredMonthValidation,
  expiredYearValidation,
} from '@/util/errorHandling'

export default {
  name: 'RechargeCardFields',

  data() {
    return {
      expiry: '',
      cardNumber: '',
      expiryMonthError: false,
      expiryYearError: false,

      credit_card: {
        info: {
          holder_name: null,
          number: null,
          expiry_month: null,
          expiry_year: null,
          ccv: null,
        },
      },

      rules: {
        name,
        required,
        expiredMonthValidation,
        expiredYearValidation,
        number: (val) =>
          (!!val && val.length >= 18) || this.$t('rules.required'),
        expiry: (val) =>
          (!!val && val.length >= 7) || this.$t('rules.required'),
        ccv: (val) => (!!val && val.length >= 2) || this.$t('rules.required'),
      },
    }
  },

  watch: {
    cardNumber() {
      if (this.cardNumber.length >= 15) {
        this.credit_card.info.number = this.cardNumber.replace(/\D/g, '')
      }
    },

    expiry() {
      if (this.expiry.length >= 7) {
        this.credit_card.info.expiry_month = this.expiry.split('/')[0]
        this.credit_card.info.expiry_year = this.expiry.split('/')[1]
      }
    },
  },

  methods: {
    ...mapMutations(['setRechargeFields']),

    handleUpdateRechargeFields() {
      this.setRechargeFields({ credit_card: this.credit_card })
    },
  },
}
</script>
